export const NO_SHIFTS_MESSAGE = "You haven't added any shift passwords yet"

export const NO_SHIFTS_DESC =
  'For extra security, we highly recommend using shift passwords.'

export const SUPPORT_LINK =
  'https://support.logmycare.co.uk/the-care-office/finishing-your-essential-setup/how-do-i-set-up-a-shift-password'
